import { ARKEMIS_CHAT as en } from 'widget/i18n/locale/en.json';
import { ARKEMIS_CHAT as ptBR } from 'widget/i18n/locale/pt_BR.json';

const DICTIONARIES = { en, pt_BR: ptBR, pt: ptBR };

export const createTranslator = locale => {
  const dictionary =
    DICTIONARIES[locale] || DICTIONARIES[String(locale).split(/[-_]/)[0]] || en;
  return (key, values = {}) => {
    const lookup = source =>
      key.split('.').reduce((node, part) => node?.[part], source);
    const text = lookup(dictionary) ?? lookup(en) ?? key;
    return text.replace(/\{(\w+)\}/g, (_, name) => values[name] ?? '');
  };
};
